import {areas, DataShape} from "../App";
import {ResponsiveLine} from "@nivo/line";
import React from "react";

const Icu = ({data, message}: { data: DataShape, message: string }) => {
    const icuData = [{
        id: areas[message],
        data: data.metricsTimeseries.filter(el => el.icuCapacityRatio !== null && el.icuCapacityRatio < 1).map(el => {
            return {
                x: el.date,
                y: el.icuCapacityRatio
            }
        })
    }]

    return (
        <ResponsiveLine
            markers={[
                {
                    axis: 'y',
                    value: 0.85,
                    lineStyle: {stroke: '#b0413e', strokeWidth: 1},
                    // legend: 'y marker at 0',
                    legendPosition: 'bottom-left',
                },
            ]}
            data={icuData}
            margin={{top: 10, right: 140, bottom: 50, left: 80}}
            xScale={{
                format: "%Y-%m-%d",
                type: "time",
                useUTC: false,
            }}
            xFormat="time:%Y-%m-%d"
            yScale={{type: 'linear', min: 'auto', max: 1, stacked: false, reverse: false}}
            // yFormat=" >-.2f"
            yFormat=" >-.0%"
            curve="cardinal"
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickValues: "every 3 month",
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: "%Y-%m",
                legend: "Date",
                legendOffset: 36,
                legendPosition: "middle"
            }}
            axisLeft={{
                // orient: 'left',
                format: ">-.0%",
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'ICU Usage',
                legendOffset: -45,
                legendPosition: 'middle'
            }}
            enablePoints={false}
            pointSize={10}
            pointColor={{theme: 'background'}}
            pointBorderWidth={2}
            pointBorderColor={{from: 'serieColor'}}
            pointLabelYOffset={-12}
            isInteractive={true}
            // useMesh={true}
            enableSlices={"x"}
            sliceTooltip={({slice}) => {
                return (
                    <div
                        style={{
                            background: 'white',
                            padding: '9px 12px',
                            border: '1px solid #ccc',
                        }}
                    >
                        <div>{slice.points[0].data.xFormatted}</div>
                        {slice.points.map(point => (
                            <div
                                key={point.id}
                                style={{
                                    color: point.serieColor,
                                    padding: '3px 0',
                                }}
                            >
                                <strong>{point.serieId}</strong> {point.data.yFormatted}
                            </div>
                        ))}
                    </div>
                )
            }}
            legends={[
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 140,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 120,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
        />
    )
}

export default Icu;